import ClicksStatsTable from './ClicksStatsTable';

export default ClicksStatsTable;
